import { Component, ElementRef, EventEmitter, forwardRef, Input, Output, Renderer2, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { faCheck, faSearch } from '@fortawesome/free-solid-svg-icons';
import { IOption } from '../models/option';

@Component({
    selector: 'app-select-single',
    templateUrl: './select-single.component.html',
    styleUrls: ['./select-single.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SelectSingleComponent),
            multi: true
        }
    ],
    standalone: false
})
export class SelectSingleComponent implements ControlValueAccessor {
  faCheck = faCheck;
  faSearch = faSearch;

  @ViewChild('toggleButton') toggleButton!: ElementRef;
  @ViewChild('menu') menu!: ElementRef;

  @Input() id: string | undefined;
  @Input() label: string | undefined;
  @Input() loading: boolean = false;
  @Input() displayOptionsCount: number = 5;
  @Input() options: IOption<any>[] = [];
  @Input() showFilter: boolean = false;
  @Output() valueChange = new EventEmitter<any>();

  filterText: string = '';

  onChange: any = () => { };
  onTouched: any = () => { };

  value: any = null;
  isMenuOpen: boolean = false;

  constructor(private _renderer: Renderer2) {
    this._renderer.listen('window', 'click', (e: Event) => {
      const isToggleButtonEl = this.toggleButton?.nativeElement && (e.target === this.toggleButton.nativeElement || this.toggleButton.nativeElement.contains(e.target));
      const isMenuEl = this.menu?.nativeElement && (e.target === this.menu.nativeElement || this.menu.nativeElement.contains(e.target));
      if (!isToggleButtonEl && !isMenuEl) {
        this.isMenuOpen = false;
      }
    });
  }

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  getSelectedLabel(): string {
    if (!this.value) {
      return 'All';
    }

    const selectedOption = this.options.find(option => option.value === this.value);
    return selectedOption ? selectedOption.label : 'All';
  }

  onSelectOptionClick(value: any) {
    this.value = this.value === value ? null : value;
    this.isMenuOpen = false;
    this.onChange(this.value);
    this.valueChange.emit(this.value);
  }

  onSelectButtonClick() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  onClearAllClick() {
    this.value = null;
    this.onChange(null);
    this.valueChange.emit('All');
  }

  clearFilterText() {
    this.filterText = '';
  }

  getOptions(): IOption<any>[] {
    if (this.showFilter && this.filterText) {
      const filterText = this.filterText.toLowerCase();
      return this.options.filter(o => o.label.toLowerCase().includes(filterText));
    }

    return this.options;
  }


}
